import React, { FC } from 'react';
import { ReactComponent as Logo } from 'application/assets/logo-black.svg';
import { LogoWrapper } from './styles';
import ProfileData from '../ProfileData';

/**
 * MyProfile functional component.
 *
 * @param props - Component properties.
 * @returns JSX element representing the profile page.
 */
const MyProfile: FC = () => {
  return (
    <>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <ProfileData />
    </>
  );
};

export default MyProfile;
